<template>
  <div>
    <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Cette permission provient d'un rôle" v-if="isDisable">
      <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" :id="name" :checked="isChecked" @change="updatePermission($event)" :disabled="isDisable">
          <label class="custom-control-label" :for="name"></label>
      </div>
    </span>
    <div class="custom-control custom-switch" v-else>
        <input type="checkbox" class="custom-control-input" :id="name" :checked="isChecked" @change="updatePermission($event)" :disabled="isDisable">
        <label class="custom-control-label" :for="name"></label>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    name: String,
    checked: String,
    disable: String,
    userId: String,
    roleId: String,
  },

  computed: {
    isChecked() {
      return parseInt(this.checked, 10) === 1
    },

    isDisable() {
      return parseInt(this.disable, 10) === 1
    },

    hasUserId() {
      return this.userId
    },

     hasRoleId() {
      return this.roleId
    },
  },

  methods: {
    updatePermission() {
      if (this.hasUserId) {
        axios.post(`/webapi/users/${this.userId}/permissions`, {
          permission: this.name
        })
        .then((res) => {
          console.log('success', res)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      }

       if (this.hasRoleId) {
        axios.post(`/webapi/roles/${this.roleId}/permissions`, {
          permission: this.name
        })
        .then((res) => {
          console.log('success', res)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      }
    }
  }
}
</script>
